import styled from "styled-components"

export const Wrapper = styled.div<{ $gridTemplateColumns?: string }>`
  column-gap: 20px;
  display: grid;
  grid-template-columns: ${({ $gridTemplateColumns }) => $gridTemplateColumns};
  row-gap: 10px;

  & .MuiTextField-root {
    width: 100%;
  }
`
